import React, { Suspense, lazy } from 'react';
import { Navigate, Routes, Route, BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';
//
import Loader from '@iso/components/utility/loader';
import { PUBLIC_ROUTE } from './route.constants';
import { useSelector } from 'react-redux';
//
const Dashboard = lazy(() => import('./containers/Dashboard/Dashboard'));
const AdminCRUD = lazy(() => import('@iso/containers/AdminCRUD/AdminCRUD') )
const DashboardFinance = lazy(() => import('./containers/Dashboard/DashboardFinance'));


const publicRoutes = [
  {
    path: PUBLIC_ROUTE.LANDING,
    exact: true,
    component: lazy(() => import('@iso/containers/Pages/SignIn/SignIn')),
  },
  {
    path: PUBLIC_ROUTE.PAGE_404,
    component: lazy(() => import('@iso/containers/Pages/404/404')),
  },
  {
    path: PUBLIC_ROUTE.PAGE_500,
    component: lazy(() => import('@iso/containers/Pages/500/500')),
  },
  {
    path: PUBLIC_ROUTE.SIGN_IN,
    component: lazy(() => import('@iso/containers/Pages/SignIn/SignIn')),
  },
  {
    path: PUBLIC_ROUTE.SIGN_UP,
    component: lazy(() => import('@iso/containers/Pages/SignUp/SignUp')),
    exact: true,
  },
  {
    path: PUBLIC_ROUTE.FORGET_PASSWORD,
    component: lazy(() => import('@iso/containers/Pages/ForgotPassword/ForgotPassword')),
  },
  {
    path: PUBLIC_ROUTE.RESET_PASSWORD,
    component: lazy(() => import('@iso/containers/Pages/ResetPassword/ResetPassword')),
  },
  {
    path: PUBLIC_ROUTE.AUTH0_CALLBACK,
    component: lazy(() => import('@iso/containers/Authentication/Auth0/Auth0Callback')),
  },
  {
    path: PUBLIC_ROUTE.DEBUG, component: () => {
      let debug_d = { ...process.env }

      // try load :gitref fr envvar REACT_APP_GITREF
      const gitref = process.env.REACT_APP_GITREF || ''
      if (  gitref) {
        debug_d['gitref'] = gitref ? gitref.split(' | ') : null
      }

      return (<>
        <pre id="debug_d">{JSON.stringify(debug_d, null, 2)}</pre>
      </>)
    },
  }
];

function PrivateRoute({ children, ...rest }) {
  const isLoggedIn = useSelector((state) => state.Auth.idToken);
  if (!isLoggedIn) {
    return (window.location.pathname = '/admin/signin');
  }

  return <Dashboard />;
}

function AdminCRUDRoute({ children, ...rest }) {
  const isLoggedIn = useSelector(state => state.Auth.idToken)
  if  (!isLoggedIn) { return (window.location.pathname = '/admin/signin') }

  return (<>
    <AdminCRUD />
  </>)
}

export default function AppRoute() {
  const { me } = useSelector((state) => state.user);
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <BrowserRouter>
          <Routes>

            <Route
              index
              element={
                <>{me?.userRole === 'admin' ? <Navigate to='/admin/dashboard/opportunities' /> : <Navigate to='/admin/dashboard/finance' />}</>
              }
            />

            {publicRoutes.map((route, index) => (
              <Route index={route.path === PUBLIC_ROUTE.SIGN_IN} key={index} path={route.path} exact={route.exact} element={<route.component />} />
            ))}

            <Route path='/admin/dashboard/*' element={<PrivateRoute />} />
            <Route path='/admin/crud/*'      element={<AdminCRUDRoute />} />
            {/* catch-all notfound */}
            {/* catch-all: redirect về 404 */}
            <Route path="*" element={<Navigate to={PUBLIC_ROUTE.PAGE_404} replace />} />

            {/* <Route path='/finance/dashboard/*' element={<PrivateRoute />} /> */}

            {/* <Route path='/' element={<PrivateRoute />} /> */}
          </Routes>
        </BrowserRouter>
      </Suspense>
    </ErrorBoundary>
  );
}
